import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import deviceAction from '@state/device/actions';
import useVariables from '@common/hooks/useVariables';

function useCondicionesAlarma({ form }) {

  const dispatch = useDispatch();
  const { getAlarmsFields } = useVariables();

  const conditions = useSelector(({ device: a }) => a.createEditValues.conditions);
  const isEditDefault = useSelector(({ device }) => device.isEditDefault);

  const [geofences, setGeofences] = useState({ next: null, results: null });
  // const [conditions, setConditions] = useState(form.getFieldValue('conditions') || []);

  const addNewGroupConditions = useCallback(() => {

    dispatch(deviceAction.addCreateEditValuesGroupConditions());
    // eslint-disable-next-line
  }, []);

  const removeGroupCondition = useCallback((index) => {

    dispatch(deviceAction.removeCreateEditValuesGroupConditions(index));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {

    if (conditions.length === 0) addNewGroupConditions();
    getAlarmsFields();
    // eslint-disable-next-line
  }, []);

  return {
    conditions,
    addNewGroupConditions,
    removeGroupCondition,
    geofences,
    setGeofences,
    isEditDefault,
  };

}

export default useCondicionesAlarma;
